import { Container, FlexGrid, Image, Visibility } from '@gasbuddy/react-components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useGeoIpInfo from '../../../lib/hooks/useGeoIpInfo';
import { COUNTRY_CODES } from '../../constants';
import Page from '../Page';
import RegionContainer from '../RegionContainer';

export default function RegionSelectPage() {
  const { t } = useTranslation('marketing');
  const defaultCountry = useGeoIpInfo().country;
  const pageMeta = useMemo(() => ({
    Country: defaultCountry,
  }), [defaultCountry]);
  const countryCodes = Object.values(COUNTRY_CODES);

  // Re-order countries if needed
  if (defaultCountry !== COUNTRY_CODES.USA) {
    countryCodes.splice(countryCodes.indexOf(defaultCountry), 1);
    countryCodes.unshift(defaultCountry);
  }

  return (
    <Page
      name="Region_Select"
      meta={pageMeta}
      withTopAd
    >
      <Container>
        <FlexGrid container>
          <FlexGrid.Column desktop={8} tablet={7}>
            {
              countryCodes.map(countryCode => (
                <RegionContainer key={countryCode} country={countryCode} isFlagInHeader />
              ))
            }
          </FlexGrid.Column>
          <FlexGrid.Column desktop={4} tablet={5}>
            <Visibility tablet={false} mobile={false}>
              <br />
              <a href="https://routing.gasbuddy.com/app" target="_blank" rel="noopener noreferrer">
                <Image
                  src="https://images.gasbuddy.com/images/websites/gasbuddy/announcements/MidAd1-1.png"
                  alt={t('appPromo.downloadApp', { ns: 'marketing' })}
                />
              </a>
            </Visibility>
          </FlexGrid.Column>
        </FlexGrid>
      </Container>
    </Page>
  );
}
